// Utilities
const getScrollTop = (): number =>
    typeof window !== "undefined"
      ? window.scrollY ?? document.documentElement.scrollTop ?? 0
      : 0;
  
  const setTriangleOffset = (el: HTMLElement): void => {
    const secondModule = el.querySelector<HTMLElement>(".module:nth-child(2)");
    const fourthModule = el.querySelector<HTMLElement>(".module:nth-child(4)");

    if(secondModule) {
        el.style.setProperty("--first-triangle-offset", `${Math.round(secondModule.offsetTop)}px`);
    }

    if(fourthModule) {
        el.style.setProperty("--second-triangle-offset", `${Math.round(fourthModule.offsetTop)}px`);
    }
  };
  
  /**
   * Initialize the dynamic top offset for the triangle that's positioned `fixed`.
   * Pass the id of the module that owns the ::after triangle.
   *
   * Returns a cleanup function to remove listeners/observers if needed.
   */
  export function initTrianglePosition(module: string): () => void {
    const el = document.querySelector(module);
  
    if (!(el instanceof HTMLElement)) {
      return () => {};
    }
  
    // Initial measurement
    setTriangleOffset(el);
  
    // Recalculate on load & resize
    const onLoad = () => setTriangleOffset(el);
    const onResize = () => setTriangleOffset(el);
  
    window.addEventListener("load", onLoad, { passive: true });
    window.addEventListener("resize", onResize, { passive: true });
  
    // Optional: update when the element’s box changes (fonts load, content expands, etc.)
    // Safe-guard for browsers that support ResizeObserver.
    let ro: ResizeObserver | undefined;
    if (typeof ResizeObserver !== "undefined") {
      ro = new ResizeObserver(() => setTriangleOffset(el));
      ro.observe(el);
    }
  
    // Cleanup
    return () => {
      window.removeEventListener("load", onLoad);
      window.removeEventListener("resize", onResize);
      ro?.disconnect();
    };
  }  